import { render, staticRenderFns } from "./service-today-activity.vue?vue&type=template&id=4683f6aa&"
import script from "./service-today-activity.vue?vue&type=script&lang=js&"
export * from "./service-today-activity.vue?vue&type=script&lang=js&"
import style0 from "./service-today-activity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports